import { setBrands } from '../setBrands'
import { AdsBrandsApi } from '../../api'

export const fetchBrands = category => async dispatch => {
  const api = new AdsBrandsApi()
  const brands = await api.getBrandsByCategory(category)
  dispatch(setBrands(brands))
}
